(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-page"]) return;
  try {
    
(function () {
  document.querySelectorAll('[data-section-type="faq-page"]').forEach(function (root) {
    var links = root.querySelectorAll('[data-faq-nav]');
    links.forEach(function (link) {
      link.addEventListener('click', function () {
        links.forEach(function (l) { l.classList.remove('is-active'); });
        link.classList.add('is-active');
      });
    });

    var search = root.querySelector('[data-faq-search]');
    if (search) {
      search.addEventListener('input', function () {
        var q = search.value.trim().toLowerCase();
        root.querySelectorAll('.faq__item').forEach(function (item) {
          var text = item.textContent.toLowerCase();
          item.style.display = (!q || text.indexOf(q) !== -1) ? '' : 'none';
        });
        root.querySelectorAll('.faq__category').forEach(function (cat) {
          var visible = cat.querySelectorAll('.faq__item:not([style*="display: none"])').length;
          cat.style.display = (!q || visible > 0) ? '' : 'none';
        });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-gift-card-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.gc-product').forEach(function(root){
    var form = root.querySelector('.gc-product__form');
    if (!form) return;

    var amountEl     = root.querySelector('[data-preview-amount]');
    var noteEl       = root.querySelector('[data-preview-note]');
    var recipientEl  = root.querySelector('[data-preview-recipient]');
    var noteInput    = root.querySelector('[data-note-input]');
    var noteCount    = root.querySelector('[data-note-count]');
    var nameInput    = root.querySelector('[data-recipient-name]');
    var variantInput = root.querySelector('[data-variant-id]');
    var ctaPrice     = root.querySelector('[data-cta-price]');

    // Denomination picker
    root.querySelectorAll('.gc-product__denom').forEach(function(btn){
      btn.addEventListener('click', function(){
        if (btn.hasAttribute('disabled')) return;
        root.querySelectorAll('.gc-product__denom').forEach(function(b){
          b.classList.remove('is-active');
          b.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-checked', 'true');
        if (variantInput) variantInput.value = btn.getAttribute('data-variant');
        var price = btn.getAttribute('data-price') || '';
        if (amountEl) amountEl.textContent = price;
        if (ctaPrice) ctaPrice.textContent = price;
      });
    });

    // Note live preview + char count
    if (noteInput) {
      noteInput.addEventListener('input', function(){
        var v = noteInput.value.trim();
        if (noteEl) noteEl.textContent = v ? '\u201C' + v + '\u201D' : '\u201CA short note will appear here as you type.\u201D';
        if (noteCount) noteCount.textContent = String(noteInput.value.length);
      });
    }

    // Recipient preview
    if (nameInput) {
      nameInput.addEventListener('input', function(){
        var v = nameInput.value.trim();
        if (recipientEl) recipientEl.textContent = v ? 'For \u00B7 ' + v : 'For \u00B7 —';
      });
    }

    // "Send as a gift" toggle — reveals recipient block + toggles required on recipient email
    var sendToggle   = root.querySelector('[data-send-toggle]');
    var recipientBox = root.querySelector('[data-recipient-fields]');
    var recipientReq = root.querySelector('[data-recipient-required]');

    function syncRecipient(){
      if (!sendToggle || !recipientBox) return;
      var on = sendToggle.checked;
      if (on) {
        recipientBox.hidden = false;
        recipientBox.removeAttribute('hidden');
        if (recipientReq) recipientReq.setAttribute('required', 'required');
      } else {
        recipientBox.hidden = true;
        recipientBox.setAttribute('hidden', 'hidden');
        if (recipientReq) recipientReq.removeAttribute('required');
      }
    }

    if (sendToggle) {
      sendToggle.addEventListener('change', syncRecipient);
      syncRecipient();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
